import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";

export default function AuditLogs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit-logs").then(r => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6 animate-in">
      <div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Governance</div>
        <h1 className="font-serif-display text-3xl">Audit Logs</h1>
      </div>
      <Card className="overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/50 text-[11px] uppercase tracking-wider text-muted-foreground">
            <tr><th className="text-left px-4 py-3">When</th><th className="text-left px-4 py-3">User</th><th className="text-left px-4 py-3">Module</th><th className="text-left px-4 py-3">Action</th><th className="text-left px-4 py-3">Record</th></tr>
          </thead>
          <tbody>
            {items.map(a => (
              <tr key={a.id} className="border-t border-border">
                <td className="px-4 py-2 text-xs text-muted-foreground">{new Date(a.created_at).toLocaleString()}</td>
                <td className="px-4 py-2">{a.user_name}</td>
                <td className="px-4 py-2">{a.module}</td>
                <td className="px-4 py-2 capitalize">{a.action}</td>
                <td className="px-4 py-2 font-mono text-xs">{a.record_id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
